// Utility to safely access window object (SSR-safe)

export const isBrowser = typeof window !== 'undefined';


export const getWindowLocation = () => {
  return isBrowser ? window.location : undefined;
};

export const getWindowHistory = () => {
  return isBrowser ? window.history : undefined;
};


export const getWindowInnerWidth = () => {
  return isBrowser ? window.innerWidth : 0;
};

export const getWindowPageYOffset = () => {
  return isBrowser ? window.pageYOffset : 0;
};

export const safeAddEventListener = (event: string, handler: EventListener) => {
  if (isBrowser) {
    window.addEventListener(event, handler);
    return () => window.removeEventListener(event, handler);
  }
  return () => { };
};

export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    return isBrowser ? window.localStorage.getItem(key) : null;
  },
  setItem: (key: string, value: string) => {
    if (isBrowser) {
      window.localStorage.setItem(key, value);
    }
  }
};

export const safeScrollTo = (options: ScrollToOptions) => {
  if (isBrowser) {
    window.scrollTo(options);
  }
};
